import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { Color } from 'ng2-charts';
import 'chartjs-plugin-labels';

@Component({
  selector: 'app-sentiment-brand-report',
  templateUrl: './sentiment-brand-report.component.html',
  styleUrls: ['./sentiment-brand-report.component.scss']
})
export class SentimentBrandReport implements OnInit {

  @Input() dataReport: any
  title_report = 'SO SÁNH SẮC THÁI THẢO LUẬN';
  result = [];
  public doughnutChartOptions: any = {
    responsive: true,
    maintainAspectRatio: true,
    plugins: {
      labels: {
        render: 'percentage',
        fontColor: 'black',
        position: 'outside',
        precision: 1,
        arc: true,
        fontSize: 12,
        textMargin: 8,
        fontStyle: 'bold'
      }
  
    }
  }
  public doughnutChartType = 'doughnut';

  public doughnutChartLabels = ['Tích cực', 'Tiêu cực', 'Trung tính'];
  public doughnutChartData = [[0,0,0]];
  public doughnutChartColors: Color[] = [
    { backgroundColor: ["#00b050", "#c00000", "#bfbfbf"] }
  ];
  constructor() {

  }

  ngOnInit(): void {
  };
  ngOnChanges(changes: SimpleChanges) {

    this.mappingData()
  }
  mappingData() {
    if(this.dataReport && this.dataReport.data && this.dataReport.data.result) {
      if(this.dataReport.report_title) {
        this.title_report = this.dataReport.report_title;
      }
      this.result = this.dataReport.data.result;
    }
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/reports-component/sentiment-brand-report/sentiment-brand-report.component.ts